import { useState } from 'react';

import { ChatMessage } from '../components/ChatMessagesDialog';

export interface ConfirmingCheckboxesState {
  showClientInfo: boolean;
  showRequestInfo: boolean;
  showDates: boolean;
  showAdvance: boolean;
  showRate: boolean;
  showArrearRate: boolean;
  showAmounts: boolean;
  showDocuments: boolean;
  showOperationCosts: boolean;
  showExpenses: boolean;
  showAccountReceivable: boolean;
  showChatAsObservations: boolean;
  selectedChatMessages: string[];
  selectedChatMessagesObjects: ChatMessage[];
}

export interface ConfirmingCheckboxesSetters {
  setShowClientInfo: (value: boolean) => void;
  setShowRequestInfo: (value: boolean) => void;
  setShowDates: (value: boolean) => void;
  setShowAdvance: (value: boolean) => void;
  setShowRate: (value: boolean) => void;
  setShowArrearRate: (value: boolean) => void;
  setShowAmounts: (value: boolean) => void;
  setShowDocuments: (value: boolean) => void;
  setShowOperationCosts: (value: boolean) => void;
  setShowExpenses: (value: boolean) => void;
  setShowAccountReceivable: (value: boolean) => void;
  setShowChatAsObservations: (value: boolean) => void;
  setSelectedChatMessages: (value: string[]) => void;
  setSelectedChatMessagesObjects: (value: ChatMessage[]) => void;
}

export const useConfirmingCheckboxes = (): [
  ConfirmingCheckboxesState,
  ConfirmingCheckboxesSetters,
] => {
  const [showClientInfo, setShowClientInfo] = useState(true);
  const [showRequestInfo, setShowRequestInfo] = useState(true);
  const [showDates, setShowDates] = useState(true);
  const [showAdvance, setShowAdvance] = useState(true);
  const [showRate, setShowRate] = useState(true);
  const [showArrearRate, setShowArrearRate] = useState(true);
  const [showAmounts, setShowAmounts] = useState(true);
  const [showDocuments, setShowDocuments] = useState(true);
  const [showOperationCosts, setShowOperationCosts] = useState(true);
  const [showExpenses, setShowExpenses] = useState(true);
  const [showAccountReceivable, setShowAccountReceivable] = useState(true);
  const [showChatAsObservations, setShowChatAsObservations] = useState(false);
  const [selectedChatMessages, setSelectedChatMessages] = useState<string[]>(
    [],
  );
  const [selectedChatMessagesObjects, setSelectedChatMessagesObjects] =
    useState<ChatMessage[]>([]);

  const state: ConfirmingCheckboxesState = {
    showClientInfo,
    showRequestInfo,
    showDates,
    showAdvance,
    showRate,
    showArrearRate,
    showAmounts,
    showDocuments,
    showOperationCosts,
    showExpenses,
    showAccountReceivable,
    showChatAsObservations,
    selectedChatMessages,
    selectedChatMessagesObjects,
  };

  const setters: ConfirmingCheckboxesSetters = {
    setShowClientInfo,
    setShowRequestInfo,
    setShowDates,
    setShowAdvance,
    setShowRate,
    setShowArrearRate,
    setShowAmounts,
    setShowDocuments,
    setShowOperationCosts,
    setShowExpenses,
    setShowAccountReceivable,
    setShowChatAsObservations,
    setSelectedChatMessages,
    setSelectedChatMessagesObjects,
  };

  return [state, setters];
};
